import { useEffect } from "react";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { useRequestInterceptorsPpmRequest, useRequestInterceptorsRequest } from "@/hooks";
import { isDev, isProd } from "@/config/common"

const Root: React.FC = () => {
  useRequestInterceptorsRequest();
  // useRequestInterceptorsResponse();
  useRequestInterceptorsPpmRequest();

  // useEffect(() => {
  //   console.log("Root-----------", isDev, isProd, import.meta.env.VITE_NODE_ENV);
  // }, []);
  
  return (
    <>
      <ScrollRestoration
        getKey={(location, _matches) => {
          const paths: string[] = [];
          return paths.includes(location.pathname) ? location.pathname : location.key;
        }}
      />
      <Outlet />
    </>
  );
};

export default Root;
